module.exports = __webpack_public_path__ + "f84a9844f0a3cfebf0917975fadf723c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/small_85x85_icon.png
// module id = 305
// module chunks = 0